<template>

</template>

<script>
  export default {
    name: "DriverCard",
    methods:{
      showDrivers(){
        // console.log(this.serviceId)
        this.$emit('drivers',this.serviceId)
      }
    },
    props: {
      driver: [Object],
      serviceId: [Number]
    }
  }
</script>

<style scoped>

</style>
